import { useLang } from "../i18n/LanguageContext";
import { GiLockedChest, GiMoon, GiScrollUnfurled, GiWaterDrop } from "react-icons/gi";

const COPY = {
  pl: {
    label: "Podgląd Księgi",
    title: "Dom nad wodą",
    date: "Ostatni sen · zapis roboczy",
    excerpt:
      "Stałem przed domem, którego drzwi prowadziły prosto do ciemnej, spokojnej wody. W środku paliło się jedno światło.",
    readingLabel: "Odczyt wstępny",
    reading:
      "Sen wskazuje na próg między bezpiecznym miejscem a głęboką emocją, która domaga się spokojnego rozpoznania.",
    symbolsLabel: "Symbole",
    symbols: ["Woda", "Dom", "Próg", "Światło"],
    mood: "Nastrój: cichy niepokój",
    vault: "Sejf: zablokowany",
  },
  en: {
    label: "Codex preview",
    title: "House by the water",
    date: "Last dream · draft entry",
    excerpt:
      "I stood before a house whose door opened straight into dark, quiet water. Inside, a single light was burning.",
    readingLabel: "Preliminary reading",
    reading:
      "The dream points to a threshold between a safe place and a deep emotion asking to be met with calm attention.",
    symbolsLabel: "Symbols",
    symbols: ["Water", "House", "Threshold", "Light"],
    mood: "Mood: quiet unease",
    vault: "Vault: locked",
  },
};

export const DreamCodexPreview = () => {
  const { lang } = useLang();
  const copy = COPY[lang] ?? COPY.pl;

  return (
    <div
      className="mt-12 grid lg:grid-cols-12 gap-px bg-ink/10 border border-ink/10"
      data-ui="dream-codex-preview"
      data-testid="dream-codex-preview"
    >
      <div className="lg:col-span-7 bg-parchment p-8 md:p-10">
        <div className="font-accent text-[10px] uppercase tracking-[0.35em] text-gold-muted">
          {copy.label}
        </div>
        <h3 className="font-heading italic text-4xl text-ink mt-5">
          {copy.title}
        </h3>
        <div className="font-body italic text-sm text-ink-soft mt-2">
          {copy.date}
        </div>
        <p className="font-body text-base text-ink-soft leading-relaxed mt-8">
          {copy.excerpt}
        </p>

        <div className="mt-8 pt-6 border-t border-ink/10">
          <div className="flex items-center gap-3 font-accent text-[10px] uppercase tracking-[0.3em] text-gold-muted">
            <GiScrollUnfurled className="text-lg" />
            {copy.readingLabel}
          </div>
          <p className="font-body italic text-sm text-ink-soft leading-relaxed mt-3">
            {copy.reading}
          </p>
        </div>
      </div>

      <div className="lg:col-span-5 bg-parchment p-8 md:p-10 flex flex-col justify-between gap-8">
        <div>
          <div className="flex items-center gap-3 font-accent text-[10px] uppercase tracking-[0.3em] text-gold-muted">
            <GiMoon className="text-lg" />
            {copy.symbolsLabel}
          </div>
          <div className="mt-5 flex flex-wrap gap-2">
            {copy.symbols.map((symbol) => (
              <span
                key={symbol}
                className="border border-gold-muted/60 px-3 py-1.5 font-accent text-[10px] uppercase tracking-[0.18em] text-ink"
              >
                {symbol}
              </span>
            ))}
          </div>
        </div>

        <div className="grid gap-3 font-body text-sm text-ink-soft">
          <div className="flex items-center gap-3">
            <GiWaterDrop className="text-lg text-gold-muted" />
            {copy.mood}
          </div>
          <div className="flex items-center gap-3">
            <GiLockedChest className="text-lg text-gold-muted" />
            {copy.vault}
          </div>
        </div>
      </div>
    </div>
  );
};
